(function(){
    if(!window.p_wcag_styles_001) {
        // 不重复加载
        window.p_wcag_styles_001 = true;
        
        // 判断是否是需要辅助的设备/用户
        function isAccessibilityUser() { const hasScreenReader = !!(window.navigator.accessibility || window.navigator.userAgent.includes('NVDA') || window.navigator.userAgent.includes('VoiceOver')); const isKeyboardNavigation = window.isKeyboardNav; return hasScreenReader || isKeyboardNavigation; }
        // 换一个同属性、同子节点的父元素
        function moveAllContentAndReplace(oldDivSelector, newTag) { const oldDiv = document.querySelector(oldDivSelector); if (!oldDiv) return; const newDiv = document.createElement(newTag || 'div'); Array.from(oldDiv.attributes).forEach(attr => { newDiv.setAttribute(attr.name, attr.value); }); while (oldDiv.firstChild) { newDiv.appendChild(oldDiv.firstChild); } oldDiv.parentNode.replaceChild(newDiv, oldDiv); }

        // 用了键盘的大概率就是辅助类
        document.addEventListener('keydown', (e) => { if (e.key === 'Tab' || e.key === 'Enter' || e.key === ' ') { window.isKeyboardNav = true; } });

        // 传统用户不是辅助类
        document.addEventListener('click', () => { window.isKeyboardNav = false; });
        document.addEventListener('touchstart', () => { window.isKeyboardNav = false; });

        // Golbal API: bind key event
        function handleKeyPress(dom, handle) { if(!dom) return; dom.addEventListener('keydown', (event) => { const isEnter = event.key === 'Enter' || event.keyCode === 13; const isSpace = event.key === 'Space' || event.keyCode === 32; if (isEnter || isSpace) { event.preventDefault(); if(handle) handle.call(); } }); }
        window.handleKeyPress2026_v1 = handleKeyPress;

        // ready loadings
        let onDomReady = (callback) => { if (document.readyState === 'interactive' || document.readyState === 'complete') { callback(); } else { document.addEventListener('DOMContentLoaded', callback); } };
        let readyHandles = [], countObject = {};

        // fixments 001: cart overlay
        function fixSlidecarthqOverlay() {
            if(!countObject.fixSlidecarthqOverlay) countObject.fixSlidecarthqOverlay = 0; if(countObject.fixSlidecarthqOverlay > 10) { if(window.tickSlidecarthqOverlay) clearTimeout(window.tickSlidecarthqOverlay); return; }
            let obj = document.querySelector(".slidecarthq-overlay");
            if(!obj) { if(window.tickSlidecarthqOverlay) clearTimeout(window.tickSlidecarthqOverlay); countObject.fixSlidecarthqOverlay += 1; window.tickSlidecarthqOverlay = setTimeout(fixSlidecarthqOverlay, 500); return; }
            // do-it area, controlled by `.slidecarthq-overlay`'s initialization
            // 1: fix slidecart-hq overlay
            obj.setAttribute("aria-label", "Cart Overlay of Slidecarthq");
            if(obj.nextElementSibling) {
                // 2: header fix, change tag to DIV
                moveAllContentAndReplace("#slidecarthq", "aside");
                document.querySelector("#slidecarthq")?.setAttribute("aria-label", "Cart of Slidecarthq");
                moveAllContentAndReplace("#slidecarthq header.header", "div");
                // 3: svg fix
                let icons = obj.nextElementSibling.querySelectorAll("svg");
                if(icons.length > 0) {
                    Array.from(icons).forEach((icon) => {
                        icon.setAttribute("aria-label", "Open chat");
                    });
                }
            }
        }
        readyHandles.push(fixSlidecarthqOverlay);

        // fixments 002: shopify preview bar
        function fixPBarNextFrame() {
            if(!countObject.fixPBarNextFrame) countObject.fixPBarNextFrame = 0; if(countObject.fixPBarNextFrame > 10) { if(window.tickPBarNextFrame) clearTimeout(window.tickPBarNextFrame); return; }
            let obj = document.querySelector("#PBarNextFrame");
            if(!obj) { if(window.tickPBarNextFrame) clearTimeout(window.tickPBarNextFrame); countObject.fixPBarNextFrame += 1; window.tickPBarNextFrame = setTimeout(fixPBarNextFrame, 500); return; }
            obj.setAttribute("title", "Shopify Preview Bar");
        }
        readyHandles.push(fixPBarNextFrame);

        // fixments 003: anchors
        function fixIndexAnchors() {
            // header
            let sh = document.querySelector("header.as-shopify-header");
            if(sh) sh.setAttribute("aria-label", "header block of this page");
            // header - nav - cart
            let a1 = document.querySelector("a#as-cart-icon-bubble-web.dropdown-toggle.icon-btn.gray-600.lh-1.nav-link.nav-link-highlight");
            let a1Mobile = document.querySelector("a#as-cart-icon-bubble.position-relative.icon-btn.lh-1.icon-wrapper.flex-center.lead.nav-fw.nav-link.gray-600");
            if(a1) a1.setAttribute("aria-label", "open slide-cart-hq");
            if(a1Mobile) a1Mobile.setAttribute("aria-label", "open slide-cart-hq");
            // header - nav - user
            let a2 = document.querySelector("a.nav-link.icon-btn.nav-link-highlight.lh-1.icon-wrap-sm");
            let a2Mobile = document.querySelector("a.icon-btn.icon-wrapper.flex-center.lead.lh-1.nav-link.gray-600.no-transition.js-no-transition");
            if(a2) a2.setAttribute("aria-label", "open user login profile");
            if(a2Mobile) a2Mobile.setAttribute("aria-label", "open user login profile");
            // footer - contact
            let a3 = document.querySelectorAll("a.link-footer.dark.text-decoration-none.icon-wrap-md");
            if(a3 && a3.length > 0) { Array.from(a3).forEach(contact => { contact.setAttribute("aria-label", "Contact Us"); }); }
        }
        readyHandles.push(fixIndexAnchors);

        function fixProductGalleryCartKeyboard() {
            const cartButton = document.querySelector(".pb-box-250320 .pbb-right[href]");
            if(!cartButton) return;
            handleKeyPress(cartButton, () => {
                window.location.assign(cartButton.href);
            });
        }
        readyHandles.push(fixProductGalleryCartKeyboard);

        function syncProductGalleryCartCount() {
            const cartText = document.querySelector(".pb-box-250320 .pr-text");
            const cartBadge = document.querySelector(".pb-box-250320 .pr-label-inner");
            if(!cartText && !cartBadge) return;

            let refreshTimer = null;
            let observedCart = null;
            let cartObserver = null;

            function renderCartCount(itemCount) {
                if(typeof itemCount !== "number") return;
                if(cartText) cartText.textContent = `Cart(${itemCount})`;
                if(cartBadge) cartBadge.textContent = `${itemCount}`;
            }

            function refreshCartCount() {
                if(refreshTimer) clearTimeout(refreshTimer);
                refreshTimer = setTimeout(() => {
                    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : "/";
                    fetch(`${root}cart.js`, {
                        credentials: "same-origin",
                        headers: { "Accept": "application/json" }
                    })
                        .then(response => response.ok ? response.json() : null)
                        .then(cart => {
                            if(cart) renderCartCount(cart.item_count);
                        })
                        .catch(() => {});
                }, 300);
            }

            function observeSlideCart() {
                const nextCart = document.querySelector("#slidecarthq");
                if(nextCart === observedCart) return;
                if(cartObserver) cartObserver.disconnect();
                observedCart = nextCart;
                if(!observedCart) return;
                cartObserver = new MutationObserver(refreshCartCount);
                cartObserver.observe(observedCart, { childList: true, characterData: true, subtree: true });
                refreshCartCount();
            }

            observeSlideCart();
            const mountObserver = new MutationObserver(() => {
                if(!observedCart || !observedCart.isConnected || observedCart !== document.querySelector("#slidecarthq")) {
                    observeSlideCart();
                }
            });
            mountObserver.observe(document.body, { childList: true, subtree: true });

            function scheduleCartActionRefresh() {
                refreshCartCount();
                setTimeout(refreshCartCount, 900);
            }

            document.addEventListener("click", event => {
                const action = event.target.closest("#slidecarthq button[aria-label='increase quantity'], #slidecarthq button[aria-label='decrease quantity'], #slidecarthq button.remove");
                if(action) scheduleCartActionRefresh();
            }, true);

            document.addEventListener("change", event => {
                if(event.target.closest("#slidecarthq input")) scheduleCartActionRefresh();
            }, true);
        }
        readyHandles.push(syncProductGalleryCartCount);
        
        onDomReady(() => { if(readyHandles.length > 0) { readyHandles.forEach(handle => { if(!handle) return; try{ handle.call(); }catch(error){} }); } });
    }
})();

(function(){
    function moveAllContentAndReplace2(oldDiv, newTag, wcagLabel) { if (!oldDiv) return; const newDiv = document.createElement(newTag || 'div'); if(wcagLabel) { newDiv.setAttribute("aria-label", wcagLabel); } Array.from(oldDiv.attributes).forEach(attr => { newDiv.setAttribute(attr.name, attr.value); }); while (oldDiv.firstChild) { newDiv.appendChild(oldDiv.firstChild); } oldDiv.parentNode.replaceChild(newDiv, oldDiv); }

    const MAX_WAIT = 10000;
    const start = Date.now();
    const svgFlags = {communicatable: false, unfocusable: false, ariaHiddenTrue: false, rolePresentation: false};

    const observer = new MutationObserver((mutations, obs) => {
        const target = document.querySelector('[class*="HubLauncher-floatingWidget"]');
        if (target) { patchChatty(target); obs.disconnect(); return; }
        if (Date.now() - start > MAX_WAIT) { obs.disconnect(); }
    });
    
    function patchChatty(container) {
        const landmark = container.closest("[data-floating-ui-portal]");
        moveAllContentAndReplace2(landmark, "aside", "customer support chat entry");

        if(svgFlags.communicatable || svgFlags.unfocusable || svgFlags.ariaHiddenTrue || svgFlags.rolePresentation) {
            container.querySelectorAll('svg').forEach(svg => {
                if(svgFlags.communicatable) { svg.setAttribute('aria-label', 'Open chat'); svg.setAttribute('tabindex', '-1'); }
                if(svgFlags.unfocusable) { svg.setAttribute('focusable', 'false'); }
                if(svgFlags.ariaHiddenTrue) { svg.setAttribute('aria-hidden', 'true'); }
                if(svgFlags.rolePresentation) { svg.setAttribute('role', 'presentation'); }
            });
        }
        const svgWrapper = container.querySelector('span.kl-hub-icon');
        svgWrapper.setAttribute('aria-hidden', 'true');
        // svgWrapper.setAttribute('role', 'presentation');

        const outerBtn = container.closest('button') || container.querySelector('button:first-child');
        container.querySelectorAll('button').forEach(innerBtn => {
            if (innerBtn !== outerBtn) {
                const span = document.createElement('span');
                span.innerHTML = innerBtn.innerHTML;
                innerBtn.replaceWith(span);
            }
        });
    }

    observer.observe(document.body, {
        childList: true, subtree: true
    });

    setTimeout(() => { observer.disconnect(); }, 15000);
})();

(function () {
  let resizeObserver = null;
  let debounceTimer = null;
  const targetClass = 'pffs-1-mode';
  const selMedia = '.noes2u-technology-media';
  const selInner = '.noes2u-technology-inner';

  function calcHeightRule() {
    const body = document.body;
    if (!body) return;

    const mediaEl = document.querySelector(selMedia);
    const innerEl = document.querySelector(selInner);
    if (!mediaEl || !innerEl) {
      body.classList.remove(targetClass);
      return;
    }

    const mediaStyle = getComputedStyle(mediaEl);
    const innerStyle = getComputedStyle(innerEl);
    const mediaMt = parseFloat(mediaStyle.marginTop) || 0;
    const innerMt = parseFloat(innerStyle.marginTop) || 0;

    const partMedia = mediaMt + mediaEl.offsetHeight;
    const partInner = innerMt + innerEl.offsetHeight;

    const totalHeight = partMedia + partInner;
    const limitHeight = window.innerHeight * 0.85;

    if (totalHeight > limitHeight) {
      body.classList.remove(targetClass);
    } else {
      // 未超出，可使用收缩风格
      body.classList.add(targetClass);
    }
  }

  function safeTrigger() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(calcHeightRule, 60);
  }

  function initWatcher() {
    const mediaEl = document.querySelector(selMedia);
    const innerEl = document.querySelector(selInner);

    if (!mediaEl || !innerEl) {
      destroyWatcher();
      safeTrigger();
      return;
    }

    if (!resizeObserver) {
      resizeObserver = new ResizeObserver(() => {
        safeTrigger();
      });
    }

    resizeObserver.observe(mediaEl);
    resizeObserver.observe(innerEl);

    // 初次计算
    safeTrigger();
  }

  function destroyWatcher() {
    if (resizeObserver) {
      resizeObserver.disconnect();
      resizeObserver = null;
    }
  }

  window.addEventListener('resize', safeTrigger);
  document.addEventListener('DOMContentLoaded', initWatcher);

})();
